import { 
  ChatbotMessageBubble, 
  ChatbotMessageLibbie, 
  AssistantGif,
  MessageContentWrapper,
  TopMatchExpandedBox,
  ReadMoreButton,
  TopMatchAnswerText,
  MessageText,
  RoomChip
} from "./FAQSearch.style";
import { ChatMessageWithFeedback } from "./Feedback";
import axios from 'axios';

// Built at runtime: a lookbehind regex literal is a parse error on iOS < 16.4 and stops the whole app from loading
let STRAY_GT_RE = null;
try {
  STRAY_GT_RE = new RegExp('(?<![<a-zA-Z/!?])\\s*>', 'g');
} catch (e) {
  // Older Safari has no lookbehind support; skip this cleanup there
}

export const MessageRow = ({
    msg,
    index,
    isMobile,
    activeComponent,
    expandedTopMatches,
    toggleTopMatch,
    activeFeedbackIndex,
    setPendingFeedback,
    setActiveFeedbackIndex,
    setFeedbackMode,
    chatHistory,
    sessionId,
    messageId,
    query,
    handleChatContinue,
    setChatInput,
    BACKEND_API_URL,
    setLinkModalOpen,    // New prop
    setSelectedLink,       // New prop
    chatContainerRef,      // New prop for auto-scroll (container ref)
    results                // New prop to get top_match_question
  }) => {
  
    console.log('followupSuggestions', msg.followupSuggestions);
    // Function to handle link clicks
    const handleLinkClick = (e, url) => {
      e.preventDefault();
      e.stopPropagation();
      
      // Extract a title from the URL
      try {
        const urlObj = new URL(url);
        let title = 'External Resource';
        
        // Try to get a meaningful title from the URL
        if (urlObj.hostname.includes('libguides')) {
          title = 'LibGuide - ' + urlObj.pathname.split('/').filter(Boolean).pop();
        } else if (urlObj.hostname.includes('libcal')) {
          title = 'LibCal - Events';
        } else if (urlObj.hostname.includes('nus.edu.sg')) {
          title = 'NUS Resource';
        } else {
          title = urlObj.hostname.replace('www.', '');
        }
        
        setSelectedLink({ url, title });
        setLinkModalOpen(true);
      } catch (err) {
        console.error('Invalid URL:', url);
      }
    };

    const cleanAnswer = (answer) => {
      if (!answer) return '';
    
      // 1. Decode HTML entities
      let text = answer
        .replace(/&39;/g, "'")
        .replace(/&amp;/g, "&")
        .replace(/&nbsp;/g, ' ')
        .replace(/\u00A0/g, ' ')  // decode non-breaking spaces
    
        // 2. Remove style fragments & HTML tags
        .replace(/style[^\n>]+>/gi, '')
        .replace(/<\/?[^>]+>/g, '')
        .replace(/target_blank>/gi, '')
    
        // Collapse spaces/tabs
        .replace(/[ \t]+/g, ' ')
  
        // Collapse empty lines
        .replace(/\n\s*\n+/g, '\n\n')
  
        // Trim lines
        .split('\n').map(line => line.trim()).join('\n')
        .trim();
    
      //   text = text.replace(
      //   /(https?:\/\/[^\s"'<>]*[^\s"'<>.,)])/g,
      //   '<a href="$1" target="_blank" rel="noopener noreferrer">click here</a>'
      // );
        
      return text;
    };
  

    const renderContentWithLinks = (content) => {
      if (!content) return '';
    
      // --- Step 1: Sanitize malformed <a> tags from LLM before anything else ---
      let sanitized = content;
    
      // Fix well-formed <a href="url">text</a> → keep URL, preserve surrounding HTML
      sanitized = sanitized.replace(
        /<a\s+href=["'](https?:\/\/[^\s"'>]+)["'][^>]*>([\s\S]*?)<\/a>/gi,
        (_, url) => url
      );
      // Fix broken <a hrefhttps://...>text</a>
      sanitized = sanitized.replace(
        /<a\s+href(https?:\/\/[^\s"'>]+)[^>]*>([\s\S]*?)<\/a>/gi,
        (_, url) => url
      );
      // Remove orphaned fragments — but NOT <br> tags
      sanitized = sanitized.replace(/\s*target_?=?"?_?blank"?>/gi, '');
      sanitized = sanitized.replace(/\bhref="#"\s*/gi, '');
      // Remove any leftover bare > that aren't part of valid tags
      if (STRAY_GT_RE) sanitized = sanitized.replace(STRAY_GT_RE, '');

      // --- Step 2: Detect actual HTML table ---
      const hasTable = /<table[\s\S]*?<\/table>/i.test(sanitized);
    
      if (hasTable) {
        let processed = sanitized;
    
        // Style <table> — fixed layout, no overflow issues
        processed = processed.replace(
          /<table(?![^>]*style=)/gi,
          `<table style="width:100%;border-collapse:collapse;font-size:0.8rem;margin:0.5rem 0;table-layout:fixed;word-break:break-word;"`
        );
    
        processed = processed.replace(
          /(<table[^>]*>)/gi,
          `$1<colgroup><col style="width:45%"><col style="width:55%"></colgroup>`
        );
    
        // Style <thead>
        processed = processed.replace(
          /<thead(?![^>]*style=)/gi,
          `<thead style="background-color:#eef2ff;"`
        );
    
        // Style <th>
        processed = processed.replace(
          /<th(?![^>]*style=)(\s|>)/gi,
          `<th style="padding:8px 10px;border:1px solid #c7d2fe;text-align:left;font-weight:700;color:#1e3a5f;font-size:0.78rem;white-space:nowrap;"$1`
        );
    
        // Style <tbody>
        processed = processed.replace(
          /<tbody(?![^>]*style=)/gi,
          `<tbody style=""`
        );
    
        // Style <tr> — alternate row shading
        let rowIndex = 0;
        processed = processed.replace(
          /<tr(?![^>]*style=)(\s|>)/gi,
          (match, after) => {
            const bg = rowIndex++ % 2 === 0 ? '#ffffff' : '#f8faff';
            return `<tr style="background-color:${bg};border-bottom:1px solid #e0e7ff;"${after}`;
          }
        );
    
        // Style <td>
        processed = processed.replace(
          /<td(?![^>]*style=)(\s|>)/gi,
          `<td style="padding:8px 10px;border:1px solid #e0e7ff;vertical-align:top;font-size:0.78rem;color:#374151;line-height:1.4;"$1`
        );
    
        // Merge 3-column tables into 2 columns: combine td[1] and td[2] into one Details cell
        // This handles cases where LLM still generates Date | Location | Link as separate columns
        const parser = new DOMParser();
        const doc = parser.parseFromString(processed, 'text/html');
        const table = doc.querySelector('table');

        if (table) {
          const headerRow = table.querySelector('thead tr');
          const bodyRows = table.querySelectorAll('tbody tr');
          
          if (headerRow && headerRow.cells.length >= 3) {
            // Merge last two header cells into "Details"
            const cells = headerRow.cells;
            cells[1].innerHTML = 'Details';
            //eslint-disable-next-line
            cells[1].style.cssText = cells[1].style.cssText;
            // Remove extra header cells beyond index 1
            while (headerRow.cells.length > 2) {
              headerRow.deleteCell(2);
            }
            
            // Merge body row cells
            bodyRows.forEach(row => {
              if (row.cells.length >= 3) {
                // Collect all content from cells 1 onwards
                let detailsHtml = '';
                for (let i = 1; i < row.cells.length; i++) {
                  const cellContent = row.cells[i].innerHTML.trim();
                  if (cellContent) {
                    detailsHtml += (detailsHtml ? '<br>' : '') + cellContent;
                  }
                }
                // Set cell[1] to merged content
                row.cells[1].innerHTML = detailsHtml;
                // Remove extra cells beyond index 1
                while (row.cells.length > 2) {
                  row.deleteCell(2);
                }
              }
            });
            
            processed = doc.body.innerHTML;
          }
        }

        // Update colgroup to 2-column layout after potential merge
        processed = processed.replace(
          /<colgroup>[\s\S]*?<\/colgroup>/gi,
          `<colgroup><col style="width:45%"><col style="width:55%"></colgroup>`
        );
        // Replace plain URLs with styled "Click here" links
        const urlRegex = /(https?:\/\/[^\s<>"']+)/g;
        processed = processed.replace(urlRegex, (url) => {
          const cleanUrl = url.replace(/[.,;!?)]+$/, '');
          return `<a href="#" data-url="${cleanUrl}" class="external-link" style="color:#4A90E2;text-decoration:none;font-weight:500;font-size:0.78rem;">Click here</a>`;
        });
    
        // Wrap in scrollable container
        processed = processed.replace(
          /(<table[\s\S]*?<\/table>)/gi,
          `<div style="overflow-x:auto;margin:0.5rem 0;box-shadow:0 1px 4px rgba(0,0,0,0.06);">$1</div>`
        );
    
        // Convert remaining newlines to <br>
        processed = processed.replace(/\n/g, '<br/>');
    
        return processed;
      }
    
      // --- Non-table path ---
      const cleaned = cleanAnswer(sanitized);
      const urlRegex = /(https?:\/\/[^\s<>"()]+)/g;
    
      return cleaned.replace(urlRegex, (url) => {
        const cleanUrl = url
          .replace(/<[^>]*>$/g, '')
          .replace(/[.,;!?)]+$/g, '')
          .replace(/\(+$/g, '')
          .replace(/[.,;!?()]+$/g, '');
    
        return `<a href="#" data-url="${cleanUrl}" class="external-link" style="color:#4A90E2;text-decoration:none;">Click here</a>`;
      });
    };

    // Add click listener for external links
    const handleMessageClick = (e) => {
      if (e.target.classList.contains('external-link') || e.target.closest('.external-link')) {
        const linkElement = e.target.classList.contains('external-link') 
          ? e.target 
          : e.target.closest('.external-link');
        
        const url = linkElement.getAttribute('data-url');
        if (url) {
          handleLinkClick(e, url);
        }
      }
    };
  
    return (
      <ChatbotMessageBubble role={msg.role} key={index}>  
        <ChatbotMessageLibbie>
          {msg.role === "assistant" && index === chatHistory.length - 1 && !isMobile && (
            <AssistantGif
              src="/libbie/talking.gif"
              alt="assistant animation"
            />
          )}
          <MessageContentWrapper onClick={handleMessageClick}>
            <MessageText 
              variant="subtitle2" 
              role={msg.role} 
              dangerouslySetInnerHTML={{ 
                __html: renderContentWithLinks(msg.content)
              }}
            />
            
            {msg.role === "assistant" && msg.topMatchAnswer && activeComponent !== "wayfinding" && index === chatHistory.length - 1 && msg.topMatchScore > 0.05 && (
              <>
                {!expandedTopMatches[index] ? (
                  <ReadMoreButton
                    variant="text"
                    size="small"
                    onClick={() => {
                      toggleTopMatch(index);                     
                    }}
                  >
                    Read more
                  </ReadMoreButton>
                ) : (
                  <TopMatchExpandedBox onClick={handleMessageClick}>
                    <TopMatchAnswerText
                      variant="subtitle2"
                      fontSize="0.9rem"
                      dangerouslySetInnerHTML={{
                        __html: renderContentWithLinks(msg.topMatchAnswer),
                      }}
                    />
                    <ReadMoreButton
                      variant="text"
                      size="small"
                      onClick={() => {
                        toggleTopMatch(index);
                        // Auto-scroll chat container to bottom after collapsing (without shifting page)
                        setTimeout(() => {
                          if (chatContainerRef?.current) {
                            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
                          }
                        }, 100);
                      }}
                    >
                      Show less
                    </ReadMoreButton>
                  </TopMatchExpandedBox>
                )}
              </>
            )}
             {/* Followup Suggestions */}
             {msg.followupSuggestions && msg.followupSuggestions.length > 0 && index === chatHistory.length - 1 && (
              <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '0.5rem',
                marginTop: '1rem',
                maxWidth: '100%',
              }}>
                {msg.followupSuggestions.slice(0, 2).map((suggestion, idx) => (
                  <RoomChip
                    key={idx}
                    label={suggestion}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setChatInput(suggestion);
                      handleChatContinue(suggestion, suggestion, msg.content);
                    }}
                    variant="outlined"
                    style={{
                      cursor: 'pointer',
                      fontSize: '0.8rem',
                      maxWidth: '100%',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  />
                ))}
              </div>
            )}
          </MessageContentWrapper>
          
        </ChatbotMessageLibbie>

        {msg.role === 'assistant' && (
          <>
            <ChatMessageWithFeedback
              msg={msg} 
              msgIndex={index} 
              isActiveFeedback={activeFeedbackIndex === index}
              chatContainerRef={chatContainerRef}
              onFeedback={async (feedbackData) => {
                const message_query = chatHistory[index - 1]?.content || "";
                const message_response = chatHistory[index]?.content || "";
                if (feedbackData.feedbackType === 'down') {
                  // Delay sending until follow-up is complete
                  setActiveFeedbackIndex(index);
                  setFeedbackMode(true);
                  setPendingFeedback({
                    messageId, // message ID tied to that assistant message
                    feedbackType: feedbackData.feedbackType,
                    defaultText: '', // leave blank unless you want default for "Tell us more"
                    message_query,
                    message_response
                  });
                }
                else if (feedbackData.feedbackType === 'regenerate') {
                  // Use the actual query from the message index, not the current query state
                  setChatInput(message_query);
                  handleChatContinue(message_query, message_query, message_response);
                }
                else {
                  // send to backend
                  try {
                    // Get top_match_question and owner_name from results if available
                    const topMatchQuestion = results?.topMatches?.[0]?.question || null;
                    const ownerName = results?.topMatches?.[0]?.owner_name || null;
                    
                    await axios.post(`${BACKEND_API_URL}/api/feedback`, {
                      message_id: messageId,
                      feedback_type: feedbackData.feedbackType,
                      session_id: sessionId,
                      message_query,
                      message_response,
                      top_match_question: topMatchQuestion,
                      owner_name: ownerName
                    });
                  } catch(err) {
                    console.error("Feedback send failed", err);
                  }
                }
              }}
            />
           
          </>
        )}
      </ChatbotMessageBubble>
    );
  };